<template>
  <div class="guide__content--wrap" :class="{default: isDefault && !isBLogin && !isBMobile && currentIndex === 'default'}">
    <div class="default__guide--wrap" v-if="onDefaultGuide">
      <i class="icon icon--solomon" />
      <span v-html="$t('page.registration.guide.defaultGuide')"></span>
    </div>

    <div class="set-url--wrap" :class="$i18n.locale" v-if="currentIndex === 6 && isCaptureUrl && currentStep === 1">
      <div class="desc--wrap">
        <p class="title">{{ $t('page.registration.guide.step1.setURL.title') }}</p>
        <ul>
          <li class="desc" v-html="$t('page.registration.guide.step1.setURL.desc')"></li>
        </ul>
      </div>
      <figure class="img--wrap"></figure>
      <p class="figcaption">
        <span class="first-text" v-html="$t('common.uxAnalysisImage')"></span>
        <span class="second-text" v-html="$t('common.heatmapImage')"></span>
        <span class="third-text" v-html="$t('common.captureImage')"></span>
      </p>
      <div class="guide-wrap">
        <a class="match-select-guide" :href="pageAddGuideLink" target="_blank" v-html="$t('page.registration.guide.pageAddGuide')"></a>
      </div>
    </div>
    <div class="login-page--wrap" :class="$i18n.locale" v-if="isBLogin && currentStep === 1 && currentIndex !== 6 && currentIndex !== 'default'">
      <div class="login-page">
        <div class="login-input--wrap">
          <span class="name">{{ $t('page.registration.guide.step1.bLogin.name') }}</span>
          <input class="" type="text" :value="$t('page.registration.guide.step1.bLogin.nameValue')" disabled />
        </div>
        <i class="icon icon--arrow-gray-size20"></i>
        <div class="login-input--wrap">
          <span class="name">XXX</span>
          <input class="" type="text" value="XXX" disabled />
        </div>
      </div>
      <div class="desc--wrap">
        <p class="title">{{ $t('page.registration.guide.step1.bLogin.title') }}</p>
        <ul :class="$i18n.locale">
          <li class="desc" v-html="$t('page.registration.guide.step1.bLogin.desc')"></li>
          <li class="desc bLogin" v-html="$t('page.registration.guide.step1.bLogin.desc2')"></li>
        </ul>
      <a class="match-select-guide" :href="pageAddGuideLink" target="_blank" v-html="$t('page.registration.guide.pageAddGuide')"></a>
      </div>
    </div>
    <div class="device--wrap" :class="$i18n.locale" v-if="isBMobile && currentStep === 1 && currentIndex !== 'default' && currentIndex !== 6">
      <div class="device-page">
        <div class="device-bg">
          <div class="top">
            <div class="device">
              <i class="icon icon--device-phone-white"></i>
              <span class="phone">Phone</span>
              <div class="line"></div>
              <span class="percent">38.6%</span>
            </div>
            <span class="referrer">
              Referrer
            </span>
          </div>
          <div class="line"></div>
          <div class="bottom">
            <div class="new-return--wrap">
              <span class="checkbox_wrap" >
                <i class="icon icon--chkbox"></i>
                <span class="text">{{ $t('common.new') }}</span>
              </span>
              <span class="checkbox_wrap on" >
                <i class="icon icon--chkbox"></i>
                <span class="text">{{ $t('common.revisit') }}</span>
              </span>
            </div>
            <div class="line"></div>
            <div class="frequency--wrap">
              <span class="text">
                {{ $t('heatmap.cvr_exit.frequency.title') }}
              </span>
              <i class="icon icon--frequency-black"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="desc--wrap">
        <p class="title">{{ $t('page.registration.guide.step1.device.title') }}</p>
        <ul>
          <li class="desc" v-html="$t('page.registration.guide.step1.device.desc')"></li>
        </ul>
        <a class="match-select-guide" :href="pageAddGuideLink" target="_blank" v-html="$t('page.registration.guide.pageAddGuide')"></a>
      </div>
    </div>
    <div class="step1__guide--wrap" v-if="!isDefault && currentStep === 1 && !isBMobile && !isBLogin && slideCurrentIndex !== null && currentIndex !== 6">
      <Guide1 :focusContent="pageAddGuideFocusContent" :slide-current-index="slideCurrentIndex" />
    </div>

    <div class="step2__guide--wrap" v-if="currentStep === 2">
      <Guide2 :focusContent="pageAddGuideFocusContent"/>
    </div>

    <div class="step3__guide--wrap" v-if="currentStep === 3">
      <Guide3 :focusContent="pageAddGuideFocusContent"/>
    </div>

    <div class="step4__guide--wrap" v-if="currentStep === 4">
      <Guide4 :focusContent="pageAddGuideFocusContent"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Guide1 from '@/components/page-registration/Guide1'
import Guide2 from '@/components/page-registration/Guide2'
import Guide3 from '@/components/page-registration/Guide3'
import Guide4 from '@/components/page-registration/Guide4'

export default {
  components: {
    Guide1,
    Guide2,
    Guide3,
    Guide4
  },
  props: [
    'currentStep',
    'isDefault',
    'matchType',
    'bLogin',
    'bMobile'
  ],
  data () {
    return {
      isBLogin: false,
      isBMobile: false,
      slideCurrentIndex: null
    }
  },
  watch: {
    bLogin (value) {
      if (value) {
        this.isBLogin = value
        this.isBMobile = false
      } else {
        this.isBLogin = false
        if (this.bMobile) {
          this.isBMobile = true
        } else {
          this.isBMobile = false
        }
      }
    },
    bMobile (value) {
      if (value) {
        this.isBMobile = value
        this.isBLogin = false
      } else {
        this.isBMobile = false
        if (this.bLogin) {
          this.isBLogin = true
        } else {
          this.isBLogin = false
        }
      }
    },
    pageAddGuideFocusContent (value, oldValue) {
      if (value.currentContentIndex < 6) {
        this.slideCurrentIndex = this.pageAddGuideFocusContent.currentContentIndex
      }
      if (this.slideCurrentIndex === value.currentContentIndex) {
        this.isBMobile = false
        this.isBLogin = false
      }
    }
  },
  computed: {
    ...mapState([
      'pageAddGuideFocusContent'
    ]),
    pageAddGuideLink () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://forum.beusable.net/ko/solomon/post/733'
        case 'en':
          return 'https://forum.beusable.net/en/solomon/post/1433'
        case 'ja':
          return 'https://forum.beusable.net/ja/solomon/post/1626'
        default:
          return null
      }
    },
    guideUrl () {
      switch (this.$i18n.locale) {
        case 'ko':
          return 'https://dream-cdn.beusable.net/dream/files/pdf/%5BRegistration%5D_%E1%84%87%E1%85%B2%E1%84%8C%E1%85%A5%E1%84%87%E1%85%B3%E1%86%AF_%E1%84%91%E1%85%A6%E1%84%8B%E1%85%B5%E1%84%8C%E1%85%B5+%E1%84%83%E1%85%B3%E1%86%BC%E1%84%85%E1%85%A9%E1%86%A8+%E1%84%80%E1%85%A1%E1%84%8B%E1%85%B5%E1%84%83%E1%85%B3_2023.06(ko).pdf'
        case 'en':
          return 'https://dream-cdn.beusable.net/dream/files/pdf/%5BRegistration%5D_Beusable+Page+Registration+Guide_2023.06(en).pdf'
        case 'ja':
          return 'https://dream-cdn.beusable.net/dream/files/pdf/%5BRegistration%5D_%E3%83%92%E3%82%99%E3%83%A5%E3%83%BC%E3%82%B5%E3%82%99%E3%83%95%E3%82%99%E3%83%AB_%E3%83%98%E3%82%9A%E3%83%BC%E3%82%B7%E3%82%99%E7%99%BB%E9%8C%B2%E3%82%AB%E3%82%99%E3%82%A4%E3%83%88%E3%82%99_20201207(ja).pdf'
        default:
          return null
      }
    },
    currentIndex () {
      return this.pageAddGuideFocusContent.currentContentIndex
    },
    isCaptureUrl () {
      return this.currentIndex === 6 && this.currentIndex !== 'default'
    },
    onDefaultGuide () {
      return (this.isDefault && this.currentStep === 1 && !this.isBLogin && !this.isBMobile && this.currentIndex !== 6) || this.currentIndex === 'default'
    }
  }
}
</script>

<style lang="scss">
.guide__content--wrap {
  height: 100%;
  position: relative;
  z-index: 1;
  box-sizing: border-box;

  overflow: auto;
  display: flex;
  flex-direction: column;

  &.default {
    align-items: center;
    justify-content: center;
  }

  & > div {
    height: 100%;
    margin-top: 80px;
  }
  .btn__pdf-download {
    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 2;

    i {
      @include positionYcenter;
      left: -23px;
    }
    span {
      font-size: 13px;
      font-weight: 600;
      line-height: 1;
      color: #ffffff;
    }
  }

  .match-select-guide {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #FFF;
    font-size: 13px;
    font-weight: 600;
    line-height: 150%; /* 19.5px */
    margin-left: 12px;
    width: fit-content;

    &.learn-more {
      margin-left: 0;
    }
  }

  .step2__guide--wrap,
  .step3__guide--wrap,
  .step4__guide--wrap {
    ul {
      li {
        list-style: none !important;
        margin-left: 0 !important;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 100%;
    overflow: hidden;

    margin: 0 auto;
    position: relative;
    list-style: none;
    padding: 0;
    z-index: 1;

    .swiper-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      box-sizing: content-box;
      transition: left 0.3s ease;

      &.isDragging {
        transition: initial;
      }

      .swiper-slide {
        position: relative;
        ms-flex-negative: 0;
        flex-shrink: 0;
        width: 100%;
        height: 100%;
        transition-property: transform;
        margin-top: -35px;
        margin-top: 0;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;

        display: flex;
        justify-content: center;
        align-items: center;

        padding-left: 40px;
        padding-right: 40px;
        box-sizing: border-box;

        .swiper-content--wrap {
          height: 380px;
          padding: 10px 0px;
          margin-top: -110px;

          .swiper-title--wrap {
            width: 400px;
            height: 244px;
            border-radius: 10px;
            background-color: #fff;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            gap: 84px;
            align-items: center;
            padding: 20px 16px;
            box-sizing: border-box;

            .swiper-title {
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 8px;
              text-align: center;

              .title {
                color: #2F2F2F;
                font-size: 15px;
                font-weight: 600;
              }

              .sub-title {
                color: #777;
                font-size: 12px;
                font-weight: 400;
                line-height: 150%;

                .red {
                  color: #ec0047;
                }

                &.ja {
                  font-size: 11px;
                }
              }
            }

            .swiper-url--wrap {
              border-radius: 4px;
              border: 1px solid #EC0047;
              padding: 2px;
              box-sizing: border-box;

              &.simple {
                border: none;
                border-radius: initial;

                .url {
                  .box {
                    border-radius: 4px;
                    border: 1px solid #ec0047;
                    padding: 2px;
                    box-sizing: border-box;
                  }
                }
              }

              .url {
                color: #666;
                font-size: 14px;
                font-weight: 400;
                line-height: 150%; /* 21px */
                position: relative;

                &.ja {
                  font-size: 13px;
                }

                .yellow-bg {
                  background: rgba(255, 215, 56, 0.40);
                }

                .blue-bg {
                  background: rgba(112, 201, 216, 0.50);
                }

                .properties {
                  color: #FFF;
                  font-size: 12px;
                  font-weight: 400;
                  border-radius: 4px;
                  background: #666;
                  padding: 4px;
                  box-sizing: border-box;
                  height: 20px;
                  line-height: 100%;

                  &.protocol {
                    position: absolute;
                    top: -29px;
                    left: -13px;
                  }

                  &.sub-domain {
                    position: absolute;
                    bottom: -29px;
                    left: 21px;
                  }

                  &.main-domain {
                    position: absolute;
                    top: -29px;
                    left: 79px;
                  }

                  &.path {
                    position: absolute;
                    bottom: -29px;
                    left: 165px;
                  }

                  &.parameter {
                    position: absolute;
                    top: -29px;
                    right: 61px;
                  }

                  &.fragment {
                    position: absolute;
                    bottom: -29px;
                    right: -8px;
                  }
                }
              }

              &.starts-reg {
                border: none;
                display: flex;
                flex-direction: column;
                gap: 12px;

                .url {
                  color: #2F2F2F;
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 100%; /* 13px */

                  .red-bg {
                    border-radius: 4px;
                    background: #FFCCD2;
                    padding-top: 3px;
                    padding-bottom: 3px;
                    padding-left: 4px;
                    box-sizing: border-box;

                    &.article {
                      padding: 3px 0;
                    }
                  }
                }
              }
            }

            &.starts {
              gap: 19px;

              .swiper-input--wrap {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 14px;

                input {
                  width: 208px;
                  height: 32px;
                  padding: 9.5px 10px;
                  box-sizing: border-box;
                  color: #2F2F2F;
                  font-size: 13px;
                  font-weight: 400;
                  line-height: 100%; /* 13px */

                  &:disabled {
                    border-radius: 4px;
                    border: 1px solid #BBB;
                    background: #FFF;
                  }
                }

                span {
                  color: #444;
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 150%; /* 18px */
                }
              }
            }

            &.ends {
              gap: 23px;

              &.regExp {
                gap: 8px;

                .swiper-input--wrap {
                  margin-top: 41px;
                }

                .swiper-url--wrap {
                  margin-left: -50px;
                }
              }

              .swiper-input--wrap {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-top: 28px;
                margin-left: -50px;

                .inputs {
                  display: flex;
                  align-items: center;
                  gap: 4px;
                  position: relative;

                  input {
                    height: 32px;
                    padding: 9.5px 10px;
                    box-sizing: border-box;
                    color: #2F2F2F;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 100%; /* 13px */

                    &:disabled {
                      border-radius: 4px;
                      border: 1px solid #BBB;
                      background: #FFF;
                    }

                    &.domain-input {
                      width: 171px;
                    }

                    &.text-input {
                      width: 71px;
                    }

                    &.contains-input {
                      width: 93px;
                    }

                    &.reg-input {
                      width: 166px;
                    }
                  }

                  span {
                    position: absolute;
                    color: #777;
                    font-size: 13px;
                    font-weight: 600;

                    &.domain {
                      top: -18px;
                      left: 4px;
                    }

                    &.text {
                      width: 63px;
                      top: -18px;
                      right: 4px;

                      &.contains {
                        width: 85px;
                      }
                    }
                  }
                }
                span {
                  color: #444;
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 150%; /* 18px */
                }

                &.reg {
                  flex-direction: column;
                  margin-left: 0;

                  .inputs {
                    .text.contains {
                      width: 158px;
                    }
                  }
                }
              }
            }
            .swiper-input--wrap {
              &.ja {
                margin-left: 0px;
                .inputs {
                  input {
                    padding: 9.5px;
                    font-size: 12px;
                  }

                  span {
                    font-size: 12px;
                  }
                }
                span {
                  font-size: 11px;
                }
              }
            }
            .swiper-url--wrap {
              &.ja {
                .url {
                  font-size: 12px;
                }
              }
            }
          }

          .img--wrap {
            margin-left: auto;
            margin-right: auto;
            background-size: contain;
            background-repeat: no-repeat;
          }
          .desc--wrap {
            display: flex;
            flex-direction: column;
            gap: 12px;
            .title {
              color: #FFF;
              font-size: 15px;
              font-weight: 600;
            }
            ul {
              margin-top: 8px;
              display: flex;
              flex-direction: column;
              gap: 8px;

              li {
                list-style: square;
                margin-left: 10px;
                margin-top: 0;
              }

              .desc {
                font-size: 13px;
                line-height: 150%; /* 19.5px */
                color: #BBB;
                position: relative;

                strong {
                  color: #ffd100;
                }

                .yellow {
                  color: #FCE515;
                }
              }
            }
          }
        }
      }
    }

    .swiper-pagination {
      display: flex;
      position: absolute;
      bottom: 3%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;

      .dot {
        width: 8px;
        height: 8px;
        background-color: rgba(255, 255, 255, 0.35);
        border-radius: 100%;
        margin: 0 5px;
        cursor: pointer;
        display: flex;
        transition: all .3s;

        &.active {
          background: #FFF;
        }

        &:hover {
          background-color: #aaa;
        }
      }
    }
    .swiper-button-next, .swiper-button-prev {
      top: 50%;
      margin-top: -42px;
      z-index: 10;
      cursor: pointer;
      padding: 10px;
      background-position: center;
      @include positionYcenter;
    }
    .swiper-button-prev {
      left: 0px;
      right: auto;

      &.step1 {
        margin-top: -125px;
      }
    }
    .swiper-button-next {
      right: 0px;
      left: auto;
      transform: rotate(180deg) translateY(50%);

      &.step1 {
        margin-top: -125px;
      }
    }
  }

  .default__guide--wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 19px;
    margin-top: 164px;

    span {
      color: #2F2F2F;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 150%; /* 21px */
    }
  }

  .set-url--wrap {
    padding: 0 40px;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.ko {
      .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_ko.png); width: 380px; height: 126px; margin-top: 56px; }
    }
    &.ja {
      .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_ja.png); width: 380px; height: 126px; margin-top: 56px; }
    }
    &.en {
      .img--wrap { background-image: url(../../assets/img/page/regi_guide_2-7_en.png); width: 380px; height: 126px; margin-top: 56px; }
    }
    .img--wrap {
      background-size: 380px;
      background-repeat: no-repeat;
    }
    .desc--wrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 400px;
      .title {
        color: #FFF;
        font-size: 15px;
        font-weight: 600;
      }
      ul {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        li {
          list-style: square;
          margin-left: 10px;
          margin-top: 0;
        }

        .desc {
          font-size: 13px;
          line-height: 150%; /* 19.5px */
          color: #BBB;
          position: relative;

        }
      }
    }
    .figcaption {
      font-size: 12px;
      font-weight: 600;
      color: #d7d7d7;
      white-space: nowrap;

      span {
        display: inline-block;
        width: 100px;
        text-align: center;
        line-height: 1.4;
        &.first-text {
          margin-right: 40px;
        }
        &.second-text {
          margin-right: 40px;
        }
        &.third-text {
          color: #ffd100;
        }
      }
    }

    .guide-wrap {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .match-select-guide {
        margin-top: 12px;
        margin-left: 0;
        text-align: left;
      }
    }
  }

  .login-page--wrap {
    margin-top: 40px;
    padding: 0 40px;

    .login-page {
      width: 400px;
      height: 151px;
      border-radius: 10px;
      background: #F4F4F1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 14px;
      margin-bottom: 40px;

      .login-input--wrap {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .name {
          color: #777;
          font-size: 13px;
          font-weight: 400;
          line-height: 100%; /* 13px */
          margin-left: 4px;
        }

        input {
          width: 152px;
          height: 38px;
          border-radius: 5px;
          border: 1px solid #BBB;
          background: #FFF;
          padding: 12px;
          box-sizing: border-box;
        }
      }

      .icon {
        margin-top: 15px;
      }
    }

    .desc--wrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 400px;
      .title {
        color: #FFF;
        font-size: 15px;
        font-weight: 600;
      }
      ul {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &.ja {
          li {
            list-style: none;
            margin-left: 0;
          }
        }

        li {
          list-style: square;
          margin-left: 10px;
          margin-top: 0;
        }

        .desc {
          font-size: 13px;
          line-height: 150%; /* 19.5px */
          color: #BBB;
          position: relative;
          font-weight: 500;

          .yellow {
            color: #FCE515;
          }
        }
      }
    }

    .match-select-guide {
      margin-left: 0;
    }
  }

  .device--wrap {
    margin-top: 40px;
    padding: 0 40px;
    .img--wrap {
      background-size: 400px;
      background-repeat: no-repeat;
    }

    .device-page {
      width: 400px;
      height: 151px;
      border-radius: 10px;
      background: #F4F4F1;
      position: relative;
      overflow: hidden;
      margin-bottom: 40px;

      .device-bg {
        width: 540px;
        height: 126px;
        border-radius: 12px 12px 0px 0px;
        background: #FFF;
        position: absolute;
        top: 28px;
        left: 70px;

        .top {
          display: flex;
          gap: 130px;
          align-items: center;
          padding: 12px 15px;
          .device {
            padding: 9px 15px;
            box-sizing: border-box;
            width: 156px;
            height: 38px;
            border-radius: 20px;
            background: #EC0047;
            box-shadow: 0px 12px 10px -4px rgba(0, 0, 0, 0.20);
            display: flex;
            align-items: center;
            gap: 8px;

            .icon--device-phone-white {
              width: 20px;
              height: 20px;
              background-image: url(../../assets/img/heatmap/heatmap_device_phone_on.svg);
              margin-right: 2px;
            }

            span {
              color: #FFF;
              font-size: 13px;
              font-weight: 500;
              line-height: 13px; /* 100% */
            }

            .line {
              width: 1px;
              height: 12px;
              background: rgba(255, 255, 255, 0.50);
            }
          }

          .referrer {
            color: #767676;
            font-size: 14px;
            font-weight: 500;
            line-height: 14px; /* 100% */
          }
        }

        .line {
          width: 100%;
          height: 1px;
          background: #EBEBEB;
        }

        .bottom {
          padding: 22px 20px;
          display: flex;
          align-items: center;
          gap: 15px;

          .new-return--wrap {
            display: flex;
            align-items: center;
            gap: 17px;

            .checkbox_wrap {
              display: flex;
              align-items: center;
              gap: 5px;

              .text {
                color: #2F2F2F;
                font-size: 13px;
                font-weight: 400;
              }
            }
          }

          .line {
            width: 1px;
            height: 12px;
            background: #D7D7D7;
          }

          .frequency--wrap {
            display: flex;
            align-items: center;
            .text {
              color: #2F2F2F;
              font-size: 14px;
              font-weight: 500;
            }
            .icon--frequency-black {
              border: 1px solid #d7d7d7;
              border-radius: 50%;
              width: 24px;
              height: 24px;
              margin-left: 5px;
              background-image: url(../../assets/img/icon_frequency_black.svg);
              background-position: center;
            }
          }
        }
      }
    }

    .desc--wrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 400px;
      .title {
        color: #FFF;
        font-size: 15px;
        font-weight: 600;
      }
      ul {
        margin-top: 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        li {
          list-style: square;
          margin-left: 10px;
          margin-top: 0;
        }

        .desc {
          font-size: 13px;
          line-height: 150%; /* 19.5px */
          color: #BBB;
          position: relative;
          .yellow {
            color: #FCE515;
          }
        }
      }
    }

    .match-select-guide {
      margin-left: 0;
    }
  }

  .step1__guide--wrap {
    margin-top: 0px;
    .list6 {
      .tip {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        color: #FCE515;
        font-size: 12px;
        line-height: 150%; /* 18px */

        .icon {
          margin-top: 2px;
        }
      }
    }

    .list1,
    .list2,
    .list3,
    .list4,
    .list5,
    .list6 {
      .img--wrap {
        width: 400px;
        height: 244px;
        margin-top: -5px;
        margin-bottom: 20px;
      }
    }
  }
  .step2__guide--wrap {
    .list1 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_ko.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_ja.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-1_en.png); width: 336px; height: 168px;  margin-top: 6px;  margin-bottom: 21px;  }
      }
    }
    .list2 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_ko.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_ja.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_1-2_en.png); width: 316px; height: 119px;  margin-top: 29px;  margin-bottom: 47px;  }
      }
    }
  }
  .step3__guide--wrap {
    .list1 {
      .desc--wrap {  margin-top: 150px;  }
    }
    .list2 {
      .desc--wrap {  margin-top: 150px;  }
    }
    .list3 {
      .text-ex {  margin-top: 35px;   font-size: 13px;  line-height: 1.46;  color: #aaaaaa;  }
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_ko.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_ja.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_3-3_en.png);  width: 342px; height: 100px;  margin-top: 10px;  margin-bottom: 38px;  }
      }
    }
  }
  .step4__guide--wrap {
    .list1 {
      &.ko {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_ko.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
      &.ja {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_ja.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
      &.en {
        .img--wrap {  background-image: url(../../assets/img/page/regi_guide_4-1_en.png);  width: 210px;  height: 168px;  margin-bottom: 26px;  }
      }
    }
    .list2, .list3 {
      .img--wrap {
        @include flexXbetween;
        .icon {
          margin-top: 40px;
        }
      }
      figcaption {
        margin-top: 12px;
      }
      .figure-caption {
        margin-top: 18px;
      }
      figcaption, .figure-caption {
        text-align: center;
        font-size: 13px;
        line-height: 1.46;
        color: #aaaaaa;

        strong {
          color: #ffd100;
        }
      }
      .desc--wrap {
        margin-top: 40px;
      }
    }
  }
}
</style>
